import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import logo from '../../assets/images/TravelanceNew.png'
import { Popover } from 'antd'
import PackegeList from './components/PackegeList'
import { CaretDownOutlined, FacebookOutlined, InstagramOutlined, MailOutlined, TwitterOutlined, WhatsAppOutlined } from '@ant-design/icons'

const race = ['Azure Female', 'Iron Dwarf', 'Highborn Human', 'Lowland Human', 'Mountain Dwarf', 'Scythian Elf', 'Woodland Elf'];


const navList = [
    { name: "Home", link: "/" },
    { name: "About Us", link: "/aboutUs" },
    { name: "Packages", link: "/packages/international" },
    // { name: "Blogs", link: "/blogs" },
    { name: "Contact Us", link: "/contactUS" },
]

const Headers = ({ isNavActive, isMobile }) => {
    const location = useLocation();

    const [activeNav, setActiveNav] = useState(0);
    const handleActiveNav = (index) => {
        setActiveNav(index)
    }

    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };
    
    const [isOpen, setIsOpen] = useState(false);
  const [haveText, setHaveText] = useState("");

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const handleText = (ev) => {
    setIsOpen(false); // Close dropdown after selecting an item
    setMenuOpen(false)
  };

  const itemList = (items) => (
    <div className="dropdown__items">
        <Link to={'/packages/domestic'}><div
          onClick={handleText}
          className="dropdown__item"
          >
            Domestic
        </div></Link>
        <Link to={'/packages/international'}><div
          onClick={handleText}
          className="dropdown__item"
          >
            International
        </div></Link>
    </div>
  );
    

    return (
        <div className={`nav ${isNavActive  ? 'active' : ''}`}>     
           {/* || location.pathname !== '/'  */}
            <div className="container-fluid">
                <div className="logo">
                    <Link to={'/'}><img src={logo} alt="logo" width={150} height={45} /></Link>
                </div>
                {isMobile ? 
                
                <header className="header">
            <div className="nav_bar1">
                <div className="logo">
                   
                </div>
                <nav id="menu" className={menuOpen ? "show" : ""}>
                <><ul>
                    {navList.map((list, index) => {
                        return (
                            list.name === "Packages" ? 
                            <li><div
                            className={isOpen ? "dropdown active" : "dropdown"}
                            onClick={handleClick}>
                                <Link  className={`${location.pathname === "/packages/international" ||  location.pathname === "/packages/domestic" ? "current" : ""} dropdown__text`} key={index}>
                              {list.name}
                              </Link>
                            {isOpen && itemList(race)}
                          </div></li>
                                // <li key={index} onClick={() => handleActiveNav(index)}><Link  className={`${location.pathname === "/packages/international" ||  location.pathname === "/packages/domestic" ? "current" : ""}`} key={index}>{list.name} &nbsp; <CaretDownOutlined /></Link></li>
                            : <li key={index} onClick={() => handleActiveNav(index)}><Link to={list.link} onClick={()=> setMenuOpen(false)} className={`${location.pathname === list.link && "current"}`} key={index}>{list.name}</Link></li>)
                    })}
                </ul> 
                 <div className='social-icons'>
                 <ul >
                     <li><a target="_blank"  href='https://www.instagram.com/travelanceholidays/' style={{padding : 10}}><InstagramOutlined /></a></li>
                     <li><a target="_blank"  href='https://wa.me/+919600881327' style={{padding : 10}}><WhatsAppOutlined /></a></li>
                     <li><a target="_blank"  href='https://www.facebook.com/people/Travelance-Holidays/61567836713804/' style={{padding : 10}}><FacebookOutlined /></a></li>
                     <li><a target="_blank"  href='https://x.com/TravelanceHDays' style={{padding : 10}}><TwitterOutlined /></a></li>
                 </ul>
             </div>
             </>
                </nav>
                <svg
                    onClick={toggleMenu}
                    id="burger"
                    fill="#fff"
                    viewBox="0 0 448 512"
                    title="bars"
                >
                    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z" />
                </svg>
            </div>
        </header> : <><ul>
                    {navList.map((list, index) => {
                        return (
                            list.name === "Packages" ? 
                            <Popover key={index} placement="bottom"  content={<PackegeList />}>
                                <li key={index} onClick={() => handleActiveNav(index)}><Link  className={`${location.pathname === "/packages/international" ||  location.pathname === "/packages/domestic" ? "current" : ""}`} key={index}>{list.name}</Link></li>
                            </Popover> 
                            : <li key={index} onClick={() => handleActiveNav(index)}><Link to={list.link} className={`${location.pathname === list.link && "current"}`} key={index}>{list.name}</Link></li>)
                    })}
                </ul> 
                 <div >
                 <ul >
                     <li><a target="_blank" href='https://www.instagram.com/travelanceholidays/' style={{padding : 10}}><InstagramOutlined /></a></li>
                     <li><a target="_blank" href='https://wa.me/+919600881327' style={{padding : 10}}><WhatsAppOutlined /></a></li>
                     <li><a target="_blank" href='https://www.facebook.com/people/Travelance-Holidays/61567836713804/' style={{padding : 10}}><FacebookOutlined /></a></li>
                     <li><a target="_blank" href='https://x.com/TravelanceHDays' style={{padding : 10}}><TwitterOutlined /></a></li>
                 </ul>
             </div>
             </>
                }
               
            </div>
        
        </div>
    )
}

export default Headers